module.exports = __webpack_public_path__ + "img/兴三星.741cbc29.png";